import React from 'react';
import AboutUs from './components/AboutUs';
import Hero from './components/Hero';
import Quote from './components/Quote';
import Client from '../../components/reuseables/Client';
import Footer from '../../components/reuseables/Footer';
// import Team from '../../components/reuseables/Team';

function About() {
  return (
    <div>
      <Hero/>
      <AboutUs/>
      <Quote/>
      <Client/>
      {/* <Team/> */}
				<Footer/>
    </div>
  );
}

export default About;
